<p class="greeting">{{ 'greeting' | locale: { PATIENT_NAME: patient?.name || 'patient' } }}</p>

<p class="info-text">
  {{ 'rating_request' | locale }}
  <strong>{{ call?.createdAt | date: 'EEEE dd/MM/yyyy' : '' : locale | titlecase }}</strong>
  {{ 'rating_with_doctor' | locale }}
  <strong>{{ doctor?.title }} {{ doctor?.firstName }} {{ doctor?.lastName }}</strong>
</p>

@if (doctor) {
  <div class="top-content">
    <img [src]="doctor?.image" alt="Foto del médico" />
    <div class="top-content-text">
      <p class="specialty br-30">{{ call?.specialty | localizedName }}</p>
      <p class="rate">
        <span class="rate-value">{{ doctor?.reputation | number: '1.0-1' }}</span>
        <span class="rate-stars">
          <app-score [score]="doctor?.reputation"></app-score>
        </span>
      </p>
    </div>
  </div>
}
